import { LogLevel } from "@azure/msal-browser";
import { getRuntimeConfig } from "../utilities/runtimeConfig";
/**
 * Configuration object to be passed to MSAL instance on creation.
 */

export function getMsalConfig() {
    const runtimeConfig = getRuntimeConfig();

    return {
        auth: {
            clientId: "e45a4918-2634-49ff-8270-a845aada7617",
            authority: "https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0",
            redirectUri: runtimeConfig.redirectUri,
            postLogoutRedirectUri: runtimeConfig.postLogoutRedirectUri,
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: "sessionStorage", // "sessionStorage" or"localStorage"
            storeAuthStateInCookie: false,
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            return;
                    }
                },
            },
            allowNativeBroker: false,
        },
    };
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 */
export const loginRequest = {
    scopes: ["api://9fd3a1e8-de09-4f21-9960-c97254e8d30c/SRP.Interact"],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ["api://9fd3a1e8-de09-4f21-9960-c97254e8d30c/SRP.Interact"],
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const silentUserInfoRequest = {
    scopes: ["User.Read"],
    forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};

export const popupRequest = {
    scopes: ["User.Read"]
}

export const tokenRequest = {
  scopes: ["api://9fd3a1e8-de09-4f21-9960-c97254e8d30c/SRP.Interact"],
  forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};